import React, { useState, useEffect } from "react";

import Page, { Header, Body, Content } from "src/components/page";
import { NavBar, NavItem, Link } from "src/components/navigation";
import "./home.scss";

const navItems = [
  { name: "Portfolio", path: "portfolio" },
  { name: "About", path: "me" },
  { name: "Contact", path: "contact" },
  // { name: "Generative Art", path: "generative-art" },
  // { name: "Games", path: "games" },
];

const navPaths = navItems.map(({ path }) => path);
const checkIndex = i => navPaths.indexOf(i);

const Home = ({ children, location: { pathname } }) => {
  const getPath = path => path.split("/")[1];
  const currentPath = getPath(pathname);
  const isHomePath = !currentPath;

  const initialActive = isHomePath ? null : checkIndex(currentPath);

  const [activeNav, setActive] = useState(initialActive);
  const [prevIsHomePath, setPrevIsHomePath] = useState(isHomePath);
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    setActive(initialActive);
    
    if (typeof document !== 'undefined') {
      const root = document.documentElement;
      const backgroundChanged = hasLoaded && (prevIsHomePath !== isHomePath);
      
      if (!hasLoaded) {
        // First load: set class without animation
        if (isHomePath) {
          root.classList.remove('secondary-color');
        } else {
          root.classList.add('secondary-color');
        }
        setHasLoaded(true);
        setPrevIsHomePath(isHomePath);
      } else if (backgroundChanged) {
        // Only animate when background color actually changes (to/from home)
        root.classList.add('bg-animating');
        
        // Use requestAnimationFrame to ensure class is applied before animation starts
        requestAnimationFrame(() => {
          if (isHomePath) {
            root.classList.remove('secondary-color');
          } else {
            root.classList.add('secondary-color');
          }
        });
        
        setPrevIsHomePath(isHomePath);
        
        // Clean up animation class after it completes
        const cleanup = setTimeout(() => {
          root.classList.remove('bg-animating');
        }, 300);
        
        return () => clearTimeout(cleanup);
      }
    }
  }, [initialActive, isHomePath, hasLoaded, prevIsHomePath]);

  let isLoading = activeNav !== initialActive;

  const onNavClick = selected => setActive(checkIndex(getPath(selected)));

  return (
    <Page>
      <div className="HomeContainer">
        <div className="HomeContent">
          <div
            className={`HomeHeader ${isHomePath ? "HomeHeader--isBig" : ""}`}
          >
            <div className="HomeHeaderContent">
              <Link path="" onClick={onNavClick}>
                <Header text="Linden Holt-Whittaker" />
                <div className="HomeHeaderBackground" />
              </Link>

              <NavBar>
                {navItems.map(({ name, path }, i) => (
                  <NavItem
                    key={name}
                    name={name}
                    path={`/${path}`}
                    isActive={activeNav === i}
                    onClick={onNavClick}
                  />
                ))}
              </NavBar>
            </div>
          </div>

          <div
            className={`HomeBody ${
              isLoading ? "HomeBody--isLoading" : "HomeBody--hasLoaded"
            }`}
          >
            <Body>
              <Content>{children}</Content>
            </Body>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default Home;
